export function downloadPdfBlob(blob: Blob, filename: string): void {
  if (blob.type !== 'application/pdf') throw new Error('Unexpected PDF output MIME')
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.hidden = true
  document.body.append(anchor)
  anchor.click()
  anchor.remove()
  window.setTimeout(() => URL.revokeObjectURL(url), 0)
}
